import type { TOC } from '@ember/component/template-only';
import { assert } from '@ember/debug';
import { concat } from '@ember/helper';
import { trustHTML } from '@ember/template';
import { ICONS_FLAGS_MAP } from '@mylighthouse/prism-foundation';
import { eq } from 'ember-truth-helpers';

import type { IconFlagCode } from '../../types/components/prism/icon-flag.ts';
import { UNIQUE_ID, uniqueId } from '../../utils/unique-id.ts';

function getSvgCode(iconFlagCode: IconFlagCode): string {
  let svgCode = ICONS_FLAGS_MAP[iconFlagCode];

  assert(`Icon "${iconFlagCode}" does not exist`, svgCode);

  if (svgCode === undefined) {
    return '';
  }

  /*
   * Make sure that multiple SVGs on the same page don't collide with each other
   * by replacing the hardcoded prefix (see svgo config files) with a unique one.
   */
  svgCode = svgCode.replaceAll(UNIQUE_ID, uniqueId());

  return svgCode;
}

interface PrismIconFlagSignature {
  Args: {
    code: IconFlagCode;
    size?: 'small' | 'medium';
  };
}

const PrismIconFlag: TOC<PrismIconFlagSignature> = <template>
  <span
    class={{concat
      "prism-icon-flag"
      " "
      (if (eq @size "small") "prism-icon-flag--small" "prism-icon-flag--medium")
    }}
  >
    {{trustHTML (getSvgCode @code)}}
  </span>
</template>;

export default PrismIconFlag;
